import React from 'react';
import { ArrowRightIcon, CreditCardIcon } from 'lucide-react';
const lineItems = [{
  label: 'Manual integral Memorias del Alma™ (material digital completo)',
  value: '$ 84.950'
}, {
  label: '3 bonos estratégicos exclusivos',
  value: '$ 32.970'
}];
export function OfferBox() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-ink-raised" data-id="element-120" data-mp="1onvvchxxli03">
      <div className="mx-auto max-w-content px-5 py-16 lg:py-24" data-id="element-121" data-mp="2cdqchbpa9sq5">
        <div className="mx-auto max-w-3xl overflow-hidden rounded-3xl border border-amethyst/40 bg-ink" data-id="element-122" data-mp="2cei30840x09k">
          <p className="bg-amethyst-deep px-6 py-3 text-center text-[12px] font-semibold uppercase tracking-[0.18em] text-cream" data-id="element-123" data-mp="2hexfkxghe3qh">
            Oferta especial de lanzamiento
          </p>

          <div className="p-7 sm:p-10" data-id="element-124" data-mp="27l6wy971cnip">
            <h2 id="oferta-title" className="text-center font-display text-3xl text-cream sm:text-4xl" data-id="element-125" data-mp="2vcue3zehwk7s">
              Pack Memorias del Alma™
            </h2>

            <dl className="mt-9 divide-y divide-line border-y border-line" data-id="element-126" data-mp="304lx9ovbnnnw">
              {lineItems.map(item => <div key={item.label} className="flex items-baseline justify-between gap-6 py-4" data-id="element-127" data-mp="35gno7p1f2cs9">
                  <dt className="text-[15px] leading-snug text-cream/85" data-id="element-128" data-mp="30j4acq8ms20u">{item.label}</dt>
                  <dd className="shrink-0 font-sans text-[15px] tabular-nums text-muted" data-id="element-129" data-mp="3f7s6axme2drb">
                    {item.value}
                  </dd>
                </div>)}
              <div className="flex items-baseline justify-between gap-6 py-4" data-id="element-130" data-mp="3o641ze2441qm">
                <dt className="text-[15px] font-semibold text-cream" data-id="element-131" data-mp="3k5k3o75sys2w">Valor total</dt>
                <dd className="shrink-0 font-sans text-[15px] tabular-nums text-muted line-through" data-id="element-132" data-mp="1znll3qaaubw">
                  $ 117.920
                </dd>
              </div>
            </dl>

            <div className="mt-9 text-center" data-id="element-133" data-mp="3t45l1yzjg123">
              <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-amethyst" data-id="element-134" data-mp="23q8wuni7tekb">
                Oportunidad única hoy
              </p>
              <p className="mt-3 font-display text-6xl leading-none text-gold sm:text-7xl" data-id="element-135" data-mp="1yuacrc3x6ipp">
                $ 19
              </p>
              <p className="mt-3 text-[14px] text-muted" data-id="element-136" data-mp="7ndvevg5h5fz">
                o el equivalente en tu moneda local
              </p>
              <p className="mt-5 inline-flex items-center gap-2 rounded-full border border-line px-4 py-2 text-[13px] text-cream/85" data-id="element-137" data-mp="bopoxc25aatg">
                <CreditCardIcon className="h-4 w-4 text-amethyst" aria-hidden="true" data-id="element-138" data-mp="gm7nc8ijd7n7" />
                Pago único. Acceso de por vida. Sin mensualidades ni cobros recurrentes.
              </p>
            </div>

            <a href="#oferta" className="group mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-gold px-6 py-4 text-center font-sans text-[15px] font-semibold text-[#1B0F00] transition-[transform,background-color] duration-150 ease-out hover:bg-[#E8C480] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold active:scale-[0.99]" data-id="element-139" data-mp="vdgjl0gy1r9b">
              Obtener el Sistema Memorias del Alma™
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-140" data-mp="1jhzc91nvjbli" />
            </a>

            <p className="mt-5 text-center text-[13px] text-muted" data-id="element-141" data-mp="19iqm6jw4qh4f">
              Descarga inmediata · Pago seguro · Acceso de por vida · Garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}